module.exports = __webpack_public_path__ + "assets/img/17.79da4663.png";